import { render, staticRenderFns } from "./Reportistica.vue?vue&type=template&id=e706bab2"
import script from "./Reportistica.vue?vue&type=script&lang=js"
export * from "./Reportistica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports